import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { PreprocessingRulesState } from './types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: PreprocessingRulesState = {
  preprocessingRules: [],
};

export const preprocessingRules: Module<PreprocessingRulesState, RootState> = {
  state,
  getters,
  actions,
  mutations
};